export const VOLUNTEERING_PERIOD_STATUS_DECRALED = 1;
export const VOLUNTEERING_PERIOD_STATUS_APPROVED = 2;
export const VOLUNTEERING_PERIOD_STATUS_REJECTED = 3;